var _circle, _path, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FADF43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3363 35C41.3474 42.7215 33.2901 48 23.9999 48 14.7098 48 6.65246 42.7215 2.66357 35H45.3363zM45.3363 13H2.66357C6.65246 5.27852 14.7098 0 23.9999 0 33.2901 0 41.3474 5.27852 45.3363 13z",
    fill: "#E62048"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}

export default SvgEs;